module.exports = {
  "version": "0.25.0"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/axios/lib/env/data.js
// module id = 18
// module chunks = 0 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29